import React from "react";

/**
 * ajobforsure logomark
 * - Rounded-square badge with a stylized $ mark
 * - Optional wordmark next to it
 * - Uses currentColor for the wordmark so it inherits from parent
 */
export default function Logo({ size = 28, withWordmark = true, className = "" }) {
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="ajobforsure logo">
        {/* Forest badge */}
        <rect width="40" height="40" rx="10" fill="#0F3D2E"/>
        {/* Copper coin accent behind the $ */}
        <circle cx="20" cy="20" r="12" fill="#D96B27" opacity="0.18"/>
        {/* Stylized $ mark */}
        <path
          d="M20 8 V32 M25.2 13.5 C 24 11.5 22 10.5 20 10.5 C 17 10.5 15 12 15 14.4 C 15 16.6 16.5 17.6 20 18.6 C 24 19.7 25.4 21 25.4 23.3 C 25.4 26 23 27.6 20 27.6 C 17.6 27.6 15.4 26.4 14.4 24.4"
          stroke="#FBF9F5" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
        {/* Small copper spark */}
        <circle cx="30" cy="10" r="1.5" fill="#D96B27"/>
      </svg>
      {withWordmark && (
        <span className="font-display font-black text-2xl tracking-tight leading-none">
          ajobforsure
        </span>
      )}
    </span>
  );
}
